import React from "react"
import Link from "gatsby-link"
import Helmet from "react-helmet"

import {detect} from "detect-browser"

import {getJSON} from '../components/GlobalFunctions';

import Navigation from '../layouts/navigation.js'
import Footer from '../layouts/footer.js'

import Slider from '../layouts/slider.js'

import character from '../img/index_photos/character1.svg'
import character_ie from '../img/index_photos/character1_ie.svg'
import character2 from '../img/index_photos/character2.svg'
import character3 from '../img/index_photos/character3.svg'
import character4 from '../img/index_photos/character4.svg'
import character5 from '../img/index_photos/character5.svg'

import uvoworld_logo from '../img/index_photos/uvoworld_logo.svg'
import uvoworld_img from '../img/aboutus/aboutus-1.svg'

import { AreaChart, Area, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';

import review_logo from '../img/review-logo.svg'
import trustpilot from '../img/trustpilot-logo.svg'
import current_projects from '../img/current-projects.svg'
import register_now from '../img/register-now-left.svg'

import ogp_cover from '../img/cover.png'

export default class Index extends React.Component {

	constructor() {
		super();

		this.state = { 
			rImage: '',
			rImages: [character,character2,character3,character4,character5],
			average: '',
			averageOrders: '',
			dataGraph: [],
			trustScore: '',
			currentRatingWord:'',
			ratingWord: '',
			ratingListWord: [ 
				"Bad",
				"Poor",
				"Average",
				"Great",
				"Excellent"
			]
		}
	}

	pageClick(e) {
		document.getElementsByTagName('body')[0].className=''
	}

	componentDidMount() {
		var browser = detect(), self = this, mask = document.getElementById('mask'), randomInt = Math.floor(Math.random() * this.state.rImages.length);
	    mask.addEventListener('touchstart', this.pageClick, false);

		getJSON('GET', '/api/orders/available/total', null, function(data){
			if (typeof data === 'string') data = JSON.parse(data);
			self.setState({average: data.avg});
			self.setState({averageOrders: data.count});
		}, function(status){});


		getJSON('GET', '/api/trustpilot/54229a4300006400057a8430', null, function(data){
			if (typeof data === 'string') data = JSON.parse(data);
			self.setState({trustScore: data.trustScore});

			self.setState({currentRatingWord: Math.ceil((data.trustScore * 5) / 5)});
			self.setState({ratingWord: self.state.ratingListWord[self.state.currentRatingWord-1]});

		}, function(status){});

		self.setState({ dataGraph :[ { name: '2007', uv: 164 }, { name: '2008', uv: 241 }, { name: '2009', uv: 648 }, { name: '2010', uv: 548 }, { name: '2011', uv: 585 }, { name: '2012', uv: 837 }, { name: '2013', uv: 1072 }, { name: '2014', uv: 1092 }, { name: '2015', uv: 1469 }, { name: '2016', uv: 1429 }, { name: '2017', uv: 1589 },]});

		if(browser && browser.name == 'ie') {
			self.setState({rImage: character_ie});
		} else {
			self.setState({rImage: self.state.rImages[randomInt]});
		}
	}

	render() {

		return (
			<div>

				<Helmet
					title="Freelance Writing Jobs. Academic Writing Assistance Agency UvoCorp.com - UvoCorp.com"
					meta={[
						{ name: "description", content: "Freelance writing jobs online. Register now to start earning money with UvoCorp.com Registration is free." },

						{ property: 'og:title', content: "Freelance Writing Jobs. Academic Writing Assistance Agency UvoCorp.com - UvoCorp.com" },
						{ property: 'og:description', content: "Freelance writing jobs online. Register now to start earning money with UvoCorp.com Registration is free." },
						{ property: 'og:site_name', content: "UvoCorp.com" },
						{ property: 'og:type', content: "website" },
						{ property: 'og:image', content: ogp_cover },
					]}
					link={[
						{ rel: 'canonical', href: "https://www.uvocorp.com/" },
						{ rel: 'alternate', href: "https://www.uvocorp.com", hrefLang: "en" },
						{ rel: 'alternate', href: "https://canada.uvocorp.com", hrefLang: "en-ca" },
						{ rel: 'alternate', href: "https://hongkong.uvocorp.com", hrefLang: "en-hk" },
						{ rel: 'alternate', href: "https://india.uvocorp.com", hrefLang: "en-in" },
						{ rel: 'alternate', href: "https://nigeria.uvocorp.com", hrefLang: "en-ng" },
						{ rel: 'alternate', href: "https://pakistan.uvocorp.com", hrefLang: "en-pk" },
						{ rel: 'alternate', href: "https://philippines.uvocorp.com", hrefLang: "en-ph" },

						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-pl" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ro" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-bg" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-md" },
						{ rel: 'alternate', href: "https://europe.uvocorp.com", hrefLang: "en-ua" },

					]} />

				<div className="home-navigation">
					<div className='header' id="header">
					
						<Navigation />
					
					</div>
				</div>

				<div className="wrapper">

					<div className="home-header">
						<div className="container">
							<div className="home-header-text">
								<div className="home-header-title">Register now to start earning!</div>
								<div className="home-header-subtitle">UVOCORP is a freelance academic writing agency, which could offer you the perfect job!</div>
								<div className="home-header-button">
									<Link to="/register_email.html">Register now</Link>
								</div>
							</div>
							<div className="home-header-image">
								<div className="img home-header-img">
									<img id="home-header-img" src={this.state.rImage} />
								</div>
							</div>
						</div>
					</div>

					<div className="home-pricing-info">
						<div className="container">
							<p>There is no other company that offers <strong>$15</strong>/page written by an <span className="home-pricing-info-role">ESL</span> writer and <strong>$26</strong>/page completed by an <span className="home-pricing-info-role">ENL</span> writer.</p>
							<Link to="/prices.html">View Pricing <svg id="arrow-right" width="22" height="22"><path fill="#black" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></Link>
						</div>
					</div>

					<div className="home-benefits home-block-gray">
						<div className="container">
							<h1>The benefits you enjoy working as a freelance writer:</h1>
							<ul className="home-benefits-list">
								<li className="home-benefits-1">
									<p>No registration fees</p>
								</li>
								<li className="home-benefits-2">
									<p>High wages</p>
								</li>
								<li className="home-benefits-3">
									<p>Working from home</p>
								</li>
								<li className="home-benefits-4">
									<p>Orders in the sphere <br />of your interest</p>
								</li>
								<li className="home-benefits-5">
									<p>24/7 available <br />support team</p>
								</li>
								<li className="home-benefits-6">
									<p>Payments always <br />on time</p>
								</li>
								<li className="home-benefits-7">
									<p>Manage your time <br />and workload yourself</p>
								</li>
							</ul>
						</div>
					</div>

					<div className="home-block">
						<div className="container">
							<div className="row">
								<div className="col-md-push-5 col-md-7">
									<h2 className="left home-graph-h2">Who we are </h2>
									<p><Link to="/about.html">UVOCORP</Link> is a reliable partner for professional freelance writers who are looking for a trustworthy <a href="/hiring.html">long-term cooperation</a>. For those pursuing personal development, our company is also the right choice since we offer numerous interesting projects and opportunities for self-improvement. Besides, our support team members are always ready to help as they work 24/7.</p>
									<p className="home-block-regular">If writing is what you like, you are welcome to give it a try with us!</p>
								</div>
								<div className="col-md-pull-7 col-md-5 ">
									<div className="home-graph-title">Quantitative growth of writers</div>
									<div className="home-graph-date">March 2007 - November 2017</div>
									<div className="home-graph1">
										<ResponsiveContainer minHeight={250}>
											<AreaChart data={this.state.dataGraph} margin={{ top: 10, right: 15, left: 15, bottom: 0 }}>
												<defs>
													<linearGradient id="colorUv" x1="0" y1="0" x2="0" y2="1">
														<stop offset="5%" stopColor="#f29f22" stopOpacity={0.8} />
														<stop offset="95%" stopColor="#f29f22" stopOpacity={0} />
													</linearGradient>
												</defs>
												<XAxis dataKey="name" interval={0} tick={{fontSize: '11px'}} />
												<YAxis hide={true} />
												<CartesianGrid strokeDasharray="8 8" vertical={false} />
												<Area type='linear' dataKey='uv' stroke='#f29f22' fillOpacity={1} fill="url(#colorUv)" dot={{ r: 4, stroke: '#fff', fill: '#f29f22', strokeWidth: 1.5, fillOpacity: 100 }} />
											</AreaChart>
										</ResponsiveContainer>
									</div>
									<p className="home-graph-text"><span className="home-teal-color">327 writers</span> are working with us for <span className="home-teal-color">more than 3 years</span></p>
								</div>
							</div>
						</div>
					</div>

					<div className="home-block-gray home-block-gray-calltoaction">
						<div className="container">
							<p>
								You are an applicant and have questions? We will help you! 
								<Link to="/contacts.html" className="chat" >
									Contact Us
								</Link>
							</p>
						</div>
					</div>

					<div className="home-block">
						<div className="container">
							<h2>Current projects offered</h2>
							<div className="row">
								<div className="col-sm-6">
									<div className="home-block-img">
										<img src={current_projects} alt="Current projects offered"/>
									</div>
								</div>
								<div className="col-sm-6 home-current-projects-text">
									<p>Average order price: <strong className="home-teal-color">${this.state.average}</strong></p>
									<p>Currently available orders: <strong className="home-teal-color">{this.state.averageOrders}</strong></p>
									<p className="home-current-projects-link"><Link to="/view_all_orders.html">View all orders <svg id="arrow-right" width="22" height="22"><path fill="#f29f22" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></Link></p>
								</div>
							</div>
						</div>
					</div>

					<div className="home-block-gray home-block-gray-calltoaction">
						<div className="container">
							<p>Do you want to see the full pricing policy? <Link to="/prices.html">Pricing Policy</Link></p>
						</div>
					</div>


					<div className="home-block">
						<div className="container">
							<h2>What our writers say</h2>

							<Slider />

							<div className="trast">
								<div className="trast-avatar">
									<img src={review_logo} alt="avatar for trustpilot.com"/>
								</div>
								<div className="trast-info">
									<div className="trast-info-rating-stars">
										<ul className="rating">
											{Math.round(this.state.trustScore) < 1?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{Math.round(this.state.trustScore) < 2?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{Math.round(this.state.trustScore) < 3?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{Math.round(this.state.trustScore) < 4?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
											{Math.round(this.state.trustScore) < 5?(
												<li className="rating-empty"></li>
												):(
												<li></li>
											)}
										</ul>
									</div>
									<div className="trast-info-rating">
										{this.state.ratingWord} {this.state.trustScore} <span className="trast-info-gray">from 0 - 5</span>
									</div>
									<div className="trast-info-based">
										<span className="trast-info-gray">based on reviews</span>
										<img src={trustpilot} width="106" height="13" alt="trustpilot.com"/>
									</div>
									<div className="trast-info-link">
										<a href="https://www.trustpilot.com/review/uvocorp.com" target="_blank">See more reviews <svg id="arrow-right" width="22" height="22"><path fill="#1164c2" d="M17.2,10.2l-3.2,3c-0.1,0.1-0.2,0.1-0.3,0c-0.1,0-0.2-0.1-0.2-0.2v-1.9H3c-0.2,0-0.3-0.1-0.3-0.3V9.2 C2.8,9,2.9,8.9,3,8.9h10.5V7.1c0-0.1,0.1-0.2,0.2-0.2c0.1,0,0.2,0,0.3,0l3.2,2.9c0.1,0.1,0.1,0.1,0.1,0.2 C17.2,10.1,17.2,10.1,17.2,10.2z"/></svg></a>
									</div>
								</div>
							</div>


						</div>
					</div>

					<div className="home-block-gray home-uvoworld">
						<div className="container">
							<div className="col-sm-7">
								<div className="home-uvoworld-logo">
									<img src={uvoworld_logo} alt="Uvoworld Logo"/>
								</div>
								<p className="home-uvoworld-text">Stay updated with UVOworld online magazine.<br/>Let&apos;s get it written!</p>
								<div className="home-uvoworld-button">
									<a href="/uvoworld/">Read UVOworld</a>
								</div>
							</div>
							<div className="col-sm-5">
								<div className="home-uvoworld-img">
									<img src={uvoworld_img} alt="Uvoworld Image1"/>
								</div>
							</div>
						</div>
					</div>

					<div className="inner-registration inner-registration-left inner-registration-white">
						<div className="container">
							<div className="inner-registration-image">
								<div className="img inner-registration-img">
									<img src={register_now} alt="Start registration"/>
								</div>
							</div>
							<div className="inner-registration-text">
								<div className="inner-registration-title">Register now <br />to start earning!</div>
								<div className="inner-registration-button">
									<Link to="/register_email.html">Start registration</Link>
								</div>
							</div>
						</div>
					</div>

					<Footer />

				</div>
				<div id="mask" className="c-mask"></div>

			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./src/pages/index.js